import { render, staticRenderFns } from "./FeatureCheckboxes.vue?vue&type=template&id=24340998&scoped=true"
import script from "./FeatureCheckboxes.vue?vue&type=script&lang=js"
export * from "./FeatureCheckboxes.vue?vue&type=script&lang=js"
import style0 from "./FeatureCheckboxes.vue?vue&type=style&index=0&id=24340998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24340998",
  null
  
)

export default component.exports